export type LanguageName =
  | "chinese"
  | "english"
  | "french"
  | "german"
  | "hungarian"
  | "portuguese"
  | "romanian"
  | "spanish"
  | "swedish"
  | "tchech"
  | "dutch"
  | "taiwanese"
  | "italian"
  | "polish";

export const languageKeys = [
  "cs",
  "de",
  "en",
  "es",
  "fr",
  "nl",
  "hu",
  "pt",
  "ro",
  "sv",
  "zh",
  "cn",
  "tw",
  "it",
  "pl",
] as const;

export type LanguageKey = (typeof languageKeys)[number];
// The translations for one client and one language
// Maps: translationsKey -> translations string
export type TranslationsMap = Record<string, string>;

// All translations for one client
// Maps: languageName -> TranslationsMap
export type Translations = {
  [langName in LanguageName]?: TranslationsMap;
};
